module.exports = __webpack_public_path__ + "804c91553615388a8293a719c330c6b1.png";